// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__2Lj9Z","title":"ClientReferral_title__3koZ1","itemText":"ClientReferral_itemText__1KwH0"};